import {put, takeEvery, call} from 'redux-saga/effects';
import download from 'downloadjs';
import {
    DOWNLOAD_TO_EXCEL_REQUEST,
    DOWNLOAD_TO_EXCEL_SUCCESS,
    DOWNLOAD_TO_EXCEL_FAILURE,
    DOWNLOAD_TO_EXCEL,
    DOWNLOAD_TO_GDRIVE_REQUEST,
    DOWNLOAD_TO_GDRIVE_SUCCESS,
    DOWNLOAD_TO_GDRIVE_FAILURE,
    DOWNLOAD_TO_GDRIVE
} from './constants';
import Api, {ApiMethods} from 'feedback-system/middleware/api';
import {
    DownloadToExcelAction,
    DownloadToGDriveAction
} from './typedef';

function* downloadToExcel(props: DownloadToExcelAction) {
    const {periodId} = props.payload;
    try {
        yield put({type: DOWNLOAD_TO_EXCEL_REQUEST});
        const data = yield call(Api.fetch, {
            endpoint: `feedback/export/excel/${periodId}`,
            method: ApiMethods.GET
        });

        download(data.responseData, 'feedback-excel.xls');

        yield put({type: DOWNLOAD_TO_EXCEL_SUCCESS, downloaded: 'success'});

    } catch (e) {
        yield put({type: DOWNLOAD_TO_EXCEL_FAILURE, error: e});
    }
}

export function* downloadToExcelSaga() {
    yield takeEvery(DOWNLOAD_TO_EXCEL, downloadToExcel);
}

function* downloadToGDrive(props: DownloadToGDriveAction) {
    const {periodId} = props.payload;
    try {
        yield put({type: DOWNLOAD_TO_GDRIVE_REQUEST});
        const data = yield call(Api.fetch, {
            endpoint: `feedback/export/gdata/${periodId}`,
            method: ApiMethods.GET
        });

        download(data.responseData, 'feedback-excel.xls');
        yield put({type: DOWNLOAD_TO_GDRIVE_SUCCESS, downloaded: 'success'});
    } catch (e) {

        yield put({type: DOWNLOAD_TO_GDRIVE_FAILURE, error: e});
    }
}

export function* downloadToGDriveSaga() {
    yield takeEvery(DOWNLOAD_TO_GDRIVE, downloadToGDrive);
}
